/* FREYRS Lens Selector - Phase 4.7 (adds +2.75 reader power; +2.00 marked sold out; prior: plus-sphere CYL cap at -4.00; range note on Upload Rx; dual/monocular PD support; one-line Blue Light subtitle) */
(function () {
  var root = document.getElementById('freyrs-lens-root');
  if (!root) return;
  var openBtn = document.getElementById('freyrs-lens-open');
  var panel = document.getElementById('freyrs-lens-panel');
  var built = false;
  var PRICE = root.getAttribute('data-price') || '';
  var ATC_LABEL = 'Add to cart' + (PRICE ? ' \u00b7 ' + PRICE : '');

  var ICONS = {
    glasses: '<svg viewBox="0 0 24 24"><circle cx="6.5" cy="14" r="3.5"/><circle cx="17.5" cy="14" r="3.5"/><path d="M10 14h4M3 14l1.5-6M21 14l-1.5-6"/></svg>',
    book: '<svg viewBox="0 0 24 24"><path d="M12 6c-1.5-1.3-3.6-2-6-2v14c2.4 0 4.5.7 6 2 1.5-1.3 3.6-2 6-2V4c-2.4 0-4.5.7-6 2zM12 6v14"/></svg>',
    eye: '<svg viewBox="0 0 24 24"><path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"/><circle cx="12" cy="12" r="2.5"/></svg>',
    check: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M8.5 12.5l2.5 2.5 4.5-5"/></svg>'
  };

  function steps(from, to, step) {
    var out = [], v = from;
    while ((step > 0 && v <= to + 1e-9) || (step < 0 && v >= to - 1e-9)) {
      out.push(v.toFixed(2)); v = +(v + step).toFixed(2);
    }
    return out;
  }
  var SPH = steps(-7.0, 7.0, 0.25);
  var CYL = steps(0.0, -5.0, -0.25);
  var AXIS = []; for (var a = 1; a <= 180; a++) AXIS.push(String(a));
  var PD = steps(35, 79, 0.5);
  var PD_MONO = steps(25, 40, 0.5);
  var READER_POWERS = ['+1.00', '+1.25', '+1.50', '+1.75', '+2.00', '+2.25', '+2.50', '+2.75', '+3.00'];
  var SOLD_OUT_READER_POWERS = ['+2.00'];

  function fmtSigned(v) { var n = parseFloat(v); return (n > 0 ? '+' : '') + n.toFixed(2); }

  function sel(id, opts, placeholder, signed, preselect) {
    var h = '<select id="' + id + '">';
    if (placeholder !== null) h += '<option value="">' + placeholder + '</option>';
    for (var i = 0; i < opts.length; i++) {
      var selAttr = (preselect !== undefined && opts[i] === preselect) ? ' selected' : '';
      var label = signed ? fmtSigned(opts[i]) : opts[i];
      h += '<option value="' + opts[i] + '"' + selAttr + '>' + label + '</option>';
    }
    return h + '</select>';
  }

  function val(id) { var el = document.getElementById(id); return el ? el.value : ''; }

  function getSelectedVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) return input.value;
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) return m[1];
    return null;
  }

  function eyeRow(eye) {
    var p = 'freyrs-' + eye;
    var label = eye === 'od' ? '<strong>OD</strong><span>Right</span>' : '<strong>OS</strong><span>Left</span>';
    return (
      '<div class="freyrs-lens__eyecell">' + label + '</div>' +
      '<div>' + sel(p + '-sph', SPH, null, true, '0.00') + '</div>' +
      '<div>' + sel(p + '-cyl', CYL, null, true, '0.00') + '</div>' +
      '<div><select id="' + p + '-axis" disabled><option value="">\u2014</option></select></div>'
    );
  }

  function fillAxis(eye) {
    var el = document.getElementById('freyrs-' + eye + '-axis');
    if (el.options.length <= 1) {
      for (var i = 0; i < AXIS.length; i++) {
        var o = document.createElement('option');
        o.value = AXIS[i]; o.textContent = AXIS[i];
        el.appendChild(o);
      }
    }
  }

  function build() {
    panel.innerHTML =
      '<div class="freyrs-lens__eyebrow">Lens type</div>' +
      '<div class="freyrs-lens__types" role="group" aria-label="Lens type">' +
        '<button type="button" class="freyrs-lens__type" data-type="blue-light" aria-pressed="false"><span class="freyrs-lens__type-icon">' + ICONS.glasses + '</span><span class="freyrs-lens__type-title">Blue Light<span class="freyrs-lens__type-sub">Blue light filtering</span></span></button>' +
        '<button type="button" class="freyrs-lens__type" data-type="readers" aria-pressed="false"><span class="freyrs-lens__type-icon">' + ICONS.book + '</span><span class="freyrs-lens__type-title">Readers<span class="freyrs-lens__type-sub">Magnification</span></span></button>' +
        '<button type="button" class="freyrs-lens__type" data-type="prescription" aria-pressed="false"><span class="freyrs-lens__type-icon">' + ICONS.eye + '</span><span class="freyrs-lens__type-title">Prescription<span class="freyrs-lens__type-sub">Full Rx</span></span></button>' +
      '</div>' +
      '<div class="freyrs-lens__section" id="freyrs-step-readers" hidden>' +
        '<div class="freyrs-lens__sect-head">' + ICONS.book + 'Reading power</div>' +
        '<p class="freyrs-lens__sect-desc">Blue light filtering readers \u2014 uniform magnification for reading and close-up tasks. One power is applied to both lenses; no prescription required.</p>' +
        '<div class="freyrs-lens__pills" id="freyrs-pills"></div>' +
      '</div>' +
      '<div class="freyrs-lens__section" id="freyrs-step-rx" hidden>' +
        '<div class="freyrs-lens__tabs" role="tablist">' +
          '<button type="button" class="freyrs-lens__tab" data-mode="manual" aria-selected="true">Enter manually</button>' +
          '<button type="button" class="freyrs-lens__tab" data-mode="upload" aria-selected="false">Upload Rx</button>' +
        '</div>' +
        '<div id="freyrs-mode-manual">' +
          '<div class="freyrs-lens__rxgrid">' +
            '<div></div><div class="freyrs-lens__rxhead">SPH</div><div class="freyrs-lens__rxhead">CYL</div><div class="freyrs-lens__rxhead">Axis</div>' +
            eyeRow('od') + eyeRow('os') +
          '</div>' +
          '<div class="freyrs-lens__pd">' +
            '<span class="freyrs-lens__pd-label">Pupillary distance (PD)</span>' +
            '<div class="freyrs-lens__pd-row" id="freyrs-pd-single-wrap">' + sel('freyrs-pd', PD, 'Select', false) + '<span>mm</span></div>' +
            '<div class="freyrs-lens__pd-row" id="freyrs-pd-dual-wrap" hidden>' + sel('freyrs-pd-od', PD_MONO, 'Right', false) + sel('freyrs-pd-os', PD_MONO, 'Left', false) + '<span>mm</span></div>' +
            '<label class="freyrs-lens__pd-dual"><input type="checkbox" id="freyrs-pd-dual-toggle">My prescription shows two PD numbers</label>' +
          '</div>' +
        '</div>' +
        '<div id="freyrs-mode-upload" hidden>' +
          '<div class="freyrs-lens__upload">' +
            '<input type="file" id="freyrs-rx-file" accept=".jpg,.jpeg,.png,.pdf">' +
            '<div class="freyrs-lens__upload-hint">Photo or PDF of your prescription (JPG, PNG, or PDF)</div>' +
          '</div>' +
          '<div class="freyrs-lens__range-note" style="margin-top:12px;padding:10px 14px;background:#f6f6f6;border-radius:8px;font-size:12.5px;line-height:1.55;color:#555;">We can currently fill single-vision prescriptions up to \u00b17.00 sphere and \u22125.00 cylinder (\u22124.00 cylinder with plus/farsighted spheres). Prescriptions outside this range cannot be fulfilled.</div>' +
          '<div class="freyrs-lens__pd">' +
            '<span class="freyrs-lens__pd-label">Pupillary distance (PD) \u2014 optional</span>' +
            '<div class="freyrs-lens__pd-row" id="freyrs-pd-single-wrap-up">' + sel('freyrs-pd-upload', PD, 'Select if known', false) + '<span>mm</span></div>' +
            '<div class="freyrs-lens__pd-row" id="freyrs-pd-dual-wrap-up" hidden>' + sel('freyrs-pd-up-od', PD_MONO, 'Right', false) + sel('freyrs-pd-up-os', PD_MONO, 'Left', false) + '<span>mm</span></div>' +
            '<label class="freyrs-lens__pd-dual"><input type="checkbox" id="freyrs-pd-dual-toggle-up">My prescription shows two PD numbers</label>' +
            '<div class="freyrs-lens__pd-note">If your prescription doesn\u2019t include PD and none is selected, we\u2019ll use the standard 64 mm.</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="freyrs-lens__banner" id="freyrs-banner" hidden>' + ICONS.check +
        '<div><div class="freyrs-lens__banner-title" id="freyrs-banner-title"></div><div class="freyrs-lens__banner-body" id="freyrs-banner-body"></div></div>' +
      '</div>' +
      '<div class="freyrs-lens__hsa" id="freyrs-hsa" hidden>' + ICONS.check + '<span>HSA/FSA Eligible</span></div>' +
      '<label class="freyrs-lens__policy" id="freyrs-policy" hidden>' +
        '<input type="checkbox" id="freyrs-policy-check">' +
        '<span class="freyrs-lens__policy-text">I confirm my prescription is accurate and from a valid, unexpired prescription. <button type="button" class="freyrs-lens__policy-info" id="freyrs-policy-info" aria-label="About returns and remakes">?</button></span>' +
      '</label>' +
      '<div class="freyrs-lens__policy-tip" id="freyrs-policy-tip" hidden>Your lenses are cut to exactly what you enter here. And you\u2019re covered either way: every FREYRS pair \u2014 including custom prescription lenses \u2014 comes with 14-day free returns, and if we ever make an error, we\u2019ll remake your lenses free. <a href="/pages/returns" target="_blank" rel="noopener">View full return policy</a></div>' +
      '<button type="button" class="freyrs-lens__continue" id="freyrs-continue" disabled>' + ATC_LABEL + '</button>' +
      '<div class="freyrs-lens__note" id="freyrs-note"></div>';

    var typeBtns = panel.querySelectorAll('.freyrs-lens__type');
    var continueBtn = document.getElementById('freyrs-continue');
    var note = document.getElementById('freyrs-note');
    var banner = document.getElementById('freyrs-banner');
    var bannerTitle = document.getElementById('freyrs-banner-title');
    var bannerBody = document.getElementById('freyrs-banner-body');
    var state = { type: null, readerPower: null, rxMode: 'manual' };

    var policyRow = document.getElementById('freyrs-policy');
    var policyCheck = document.getElementById('freyrs-policy-check');
    var policyTip = document.getElementById('freyrs-policy-tip');
    var hsaBadge = document.getElementById('freyrs-hsa');
    document.getElementById('freyrs-policy-info').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      policyTip.hidden = !policyTip.hidden;
    });

    function atcGate() {
      continueBtn.disabled = !state.type || (state.type === 'prescription' && !policyCheck.checked);
    }
    policyCheck.addEventListener('change', atcGate);

    var pillsWrap = document.getElementById('freyrs-pills');
    READER_POWERS.forEach(function (pwr) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'freyrs-lens__pill';
      b.setAttribute('aria-pressed', 'false');
      b.dataset.power = pwr;
      if (SOLD_OUT_READER_POWERS.indexOf(pwr) !== -1) {
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
        b.title = 'This power is temporarily sold out';
        b.style.opacity = '0.45';
        b.style.cursor = 'not-allowed';
        b.innerHTML = pwr + '<span style="display:block;font-size:10px;line-height:1.3;font-weight:400;color:#999;">Sold out</span>';
      } else {
        b.textContent = pwr;
        b.addEventListener('click', function () {
          pillsWrap.querySelectorAll('.freyrs-lens__pill').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          state.readerPower = pwr;
          updateBanner();
        });
      }
      pillsWrap.appendChild(b);
    });

    var tabBtns = panel.querySelectorAll('.freyrs-lens__tab');
    tabBtns.forEach(function (t) {
      t.addEventListener('click', function () {
        tabBtns.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
        t.setAttribute('aria-selected', 'true');
        state.rxMode = t.getAttribute('data-mode');
        document.getElementById('freyrs-mode-manual').hidden = state.rxMode !== 'manual';
        document.getElementById('freyrs-mode-upload').hidden = state.rxMode !== 'upload';
        note.textContent = '';
        updateBanner();
      });
    });

    document.getElementById('freyrs-rx-file').addEventListener('change', updateBanner);
    document.getElementById('freyrs-pd-upload').addEventListener('change', updateBanner);

    function pdDual() { var t = document.getElementById('freyrs-pd-dual-toggle'); return !!(t && t.checked); }
    function pdDualUp() { var t = document.getElementById('freyrs-pd-dual-toggle-up'); return !!(t && t.checked); }
    function pdValue() {
      if (pdDual()) {
        var od = val('freyrs-pd-od'), os = val('freyrs-pd-os');
        if (!od || !os) return null;
        return 'Right: ' + parseFloat(od).toFixed(2) + ' | Left: ' + parseFloat(os).toFixed(2) + ' mm';
      }
      var p = val('freyrs-pd');
      return p ? parseFloat(p).toFixed(2) + ' mm' : null;
    }
    function pdValueUp() {
      if (pdDualUp()) {
        var od = val('freyrs-pd-up-od'), os = val('freyrs-pd-up-os');
        if (!od || !os) return null;
        return 'Right: ' + parseFloat(od).toFixed(2) + ' | Left: ' + parseFloat(os).toFixed(2) + ' mm';
      }
      var p = val('freyrs-pd-upload');
      return p ? parseFloat(p).toFixed(2) + ' mm' : null;
    }
    function bindDualToggle(toggleId, singleId, dualId) {
      document.getElementById(toggleId).addEventListener('change', function (e) {
        document.getElementById(singleId).hidden = e.target.checked;
        document.getElementById(dualId).hidden = !e.target.checked;
        updateBanner();
      });
    }
    bindDualToggle('freyrs-pd-dual-toggle', 'freyrs-pd-single-wrap', 'freyrs-pd-dual-wrap');
    bindDualToggle('freyrs-pd-dual-toggle-up', 'freyrs-pd-single-wrap-up', 'freyrs-pd-dual-wrap-up');
    ['freyrs-pd-od', 'freyrs-pd-os', 'freyrs-pd-up-od', 'freyrs-pd-up-os'].forEach(function (id) {
      document.getElementById(id).addEventListener('change', updateBanner);
    });

    function setBanner(kind, title, body) {
      banner.hidden = false;
      banner.classList.toggle('freyrs-lens__banner--danger', kind === 'danger');
      bannerTitle.textContent = title;
      bannerBody.textContent = body || '';
      bannerBody.style.display = body ? '' : 'none';
    }

    function rxComplete() {
      return val('freyrs-od-sph') !== '' && val('freyrs-od-cyl') !== '' && val('freyrs-os-sph') !== '' && val('freyrs-os-cyl') !== '';
    }

    function uploadFile() {
      var f = document.getElementById('freyrs-rx-file');
      return (f && f.files && f.files.length) ? f.files[0] : null;
    }

    function updateBanner() {
      if (state.type === 'blue-light') {
        setBanner('ok', 'No prescription needed.',
          'Your frames will ship with plano (non-corrective) blue light blocking lenses, UV400 protection, and our standard anti-reflective coating.');
        return;
      }
      if (state.type === 'readers') {
        if (state.readerPower) {
          setBanner('ok', 'Blue light filtering readers ' + state.readerPower,
            'Your frames will ship with blue light blocking magnification lenses, UV400 protection, and our standard anti-reflective coating.');
        } else { banner.hidden = true; }
        return;
      }
      if (state.type === 'prescription') {
        if (state.rxMode === 'upload') {
          if (uploadFile()) {
            var pdU = pdValueUp();
            setBanner('ok', 'Prescription file attached.',
              pdU ? 'We\u2019ll cut your lenses to the uploaded prescription with PD ' + pdU + '.'
                  : 'We\u2019ll cut your lenses to the uploaded prescription. No PD selected \u2014 the standard 64 mm will be used unless your prescription specifies one.');
          } else { banner.hidden = true; }
          return;
        }
        if (rxComplete()) {
          setBanner('ok', 'Custom cut to your prescription.', '');
        } else { banner.hidden = true; }
        return;
      }
      banner.hidden = true;
    }

    function syncAxis(eye) {
      var cyl = parseFloat(val('freyrs-' + eye + '-cyl'));
      var axisEl = document.getElementById('freyrs-' + eye + '-axis');
      if (cyl !== 0 && !isNaN(cyl)) {
        fillAxis(eye);
        axisEl.disabled = false;
        if (axisEl.options[0] && axisEl.options[0].value === '') axisEl.options[0].textContent = 'Select';
      } else {
        axisEl.disabled = true;
        axisEl.value = '';
        if (axisEl.options[0]) axisEl.options[0].textContent = '\u2014';
      }
    }

    function syncCylCap(eye) {
      var sph = parseFloat(val('freyrs-' + eye + '-sph'));
      var cylEl = document.getElementById('freyrs-' + eye + '-cyl');
      if (!cylEl) return;
      var cap = (sph > 0) ? -4.0 : -5.0;
      for (var i = 0; i < cylEl.options.length; i++) {
        var off = parseFloat(cylEl.options[i].value) < cap - 1e-9;
        cylEl.options[i].disabled = off;
        cylEl.options[i].hidden = off;
      }
      if (parseFloat(cylEl.value) < cap - 1e-9) {
        cylEl.value = cap.toFixed(2);
        syncAxis(eye);
      }
    }

    ['od', 'os'].forEach(function (eye) {
      ['sph', 'cyl'].forEach(function (f) {
        document.getElementById('freyrs-' + eye + '-' + f).addEventListener('change', function () {
          if (f === 'sph') syncCylCap(eye);
          syncAxis(eye); updateBanner();
        });
      });
      document.getElementById('freyrs-' + eye + '-axis').addEventListener('change', updateBanner);
    });
    document.getElementById('freyrs-pd').addEventListener('change', updateBanner);

    function refresh() {
      document.getElementById('freyrs-step-readers').hidden = state.type !== 'readers';
      document.getElementById('freyrs-step-rx').hidden = state.type !== 'prescription';
      policyRow.hidden = state.type !== 'prescription';
      if (policyRow.hidden) policyTip.hidden = true;
      hsaBadge.hidden = !(state.type === 'prescription' || state.type === 'readers');
      atcGate();
      note.textContent = '';
      updateBanner();
    }

    typeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        typeBtns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        state.type = b.getAttribute('data-type');
        refresh();
      });
    });

    function validate() {
      if (state.type === 'blue-light') return null;
      if (state.type === 'readers') {
        if (!state.readerPower) return 'Please select your reading power.';
        if (SOLD_OUT_READER_POWERS.indexOf(state.readerPower) !== -1) return 'That reading power is temporarily sold out. Please choose another.';
        return null;
      }
      if (state.type === 'prescription') {
        if (!policyCheck.checked) return 'Please confirm your prescription details above.';
        if (state.rxMode === 'upload') {
          if (!uploadFile()) return 'Please attach a photo or PDF of your prescription.';
          return null;
        }
        if (!rxComplete()) return 'Please complete all prescription fields.';
        if (!pdValue()) return pdDual() ? 'Please select both right and left PD values.' : 'Please select your pupillary distance (PD).';
        var odSph = parseFloat(val('freyrs-od-sph'));
        var osSph = parseFloat(val('freyrs-os-sph'));
        var odCyl = parseFloat(val('freyrs-od-cyl'));
        var osCyl = parseFloat(val('freyrs-os-cyl'));
        if (odSph > 0 && odCyl < -4.0) return 'For farsighted (plus) prescriptions, we can fill cylinders to \u22124.00. Please check your right eye values.';
        if (osSph > 0 && osCyl < -4.0) return 'For farsighted (plus) prescriptions, we can fill cylinders to \u22124.00. Please check your left eye values.';
        if (odCyl !== 0 && !val('freyrs-od-axis')) return 'Please select the right eye axis.';
        if (osCyl !== 0 && !val('freyrs-os-axis')) return 'Please select the left eye axis.';
        return null;
      }
      return 'Please select a lens type.';
    }

    var RX_CONFIRMED = 'Confirmed accurate by customer \u2014 14-day free returns apply';

    function manualProperties() {
      if (state.type === 'blue-light') {
        return { 'Lens Type': 'Blue Light', '_freyrs_rx': 'blue-light' };
      }
      if (state.type === 'readers') {
        return {
          'Lens Type': 'Readers',
          'Reading Power': state.readerPower,
          '_freyrs_rx': 'readers'
        };
      }
      var odAxis = parseFloat(val('freyrs-od-cyl')) === 0 ? '0' : val('freyrs-od-axis');
      var osAxis = parseFloat(val('freyrs-os-cyl')) === 0 ? '0' : val('freyrs-os-axis');
      return {
        'Lens Type': 'Prescription',
        'Prescription Type': 'Single Vision',
        'PD': pdValue(),
        'SPH': 'Right: ' + fmtSigned(val('freyrs-od-sph')) + ' | Left: ' + fmtSigned(val('freyrs-os-sph')),
        'CYL': 'Right: ' + fmtSigned(val('freyrs-od-cyl')) + ' | Left: ' + fmtSigned(val('freyrs-os-cyl')),
        'AXIS': 'Right: ' + odAxis + ' | Left: ' + osAxis,
        'Rx confirmation': RX_CONFIRMED,
        '_freyrs_rx': 'prescription'
      };
    }

    function finishAdd(res) {
      if (!res.ok) {
        note.textContent = res.j.description || res.j.message || 'Could not add to cart.';
        continueBtn.disabled = false;
        continueBtn.textContent = ATC_LABEL;
        return;
      }
      window.location.href = '/cart';
    }

    function failAdd() {
      note.textContent = 'Network error. Please try again.';
      continueBtn.disabled = false;
      continueBtn.textContent = ATC_LABEL;
    }

    continueBtn.addEventListener('click', function () {
      var err = validate();
      if (err) { note.textContent = err; return; }

      var variantId = getSelectedVariantId();
      if (!variantId) { note.textContent = 'Please select a color first.'; return; }

      continueBtn.disabled = true;
      continueBtn.textContent = 'Adding\u2026';
      note.textContent = '';

      if (state.type === 'prescription' && state.rxMode === 'upload') {
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        fd.append('properties[Lens Type]', 'Prescription');
        fd.append('properties[Prescription Type]', 'Single Vision');
        fd.append('properties[Prescription file]', uploadFile());
        var pdU = pdValueUp();
        fd.append('properties[PD]', pdU ? pdU : 'Not provided \u2014 64.00 mm standard will be used');
        fd.append('properties[Rx confirmation]', RX_CONFIRMED);
        fd.append('properties[_freyrs_rx]', 'prescription-upload');
        fetch('/cart/add.js', { method: 'POST', body: fd })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(finishAdd)
          .catch(failAdd);
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: manualProperties() }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(finishAdd)
        .catch(failAdd);
    });
  }

  function openPanel() {
    if (!built) { build(); built = true; }
    panel.hidden = false;
  }

  openBtn.addEventListener('click', function () {
    if (!built) { build(); built = true; }
    panel.hidden = !panel.hidden;
  });

  var sticky = document.createElement('div');
  sticky.className = 'freyrs-lens__sticky';
  sticky.innerHTML = '<button type="button" id="freyrs-sticky-open">Select lenses</button>';
  document.body.appendChild(sticky);

  document.getElementById('freyrs-sticky-open').addEventListener('click', function () {
    openPanel();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', scrolledPast);
    }, { threshold: 0 });
    io.observe(root);
  }
})();